import React from 'react';
import { View } from 'react-native';

/**
 * Web-compatible LinearGradient component that uses CSS gradients
 * This replaces react-native-linear-gradient for web builds
 */
const LinearGradient = ({
  colors = ['#000', '#fff'],
  start = { x: 0, y: 0 },
  end = { x: 1, y: 0 },
  style,
  children,
  ...props
}) => {
  // Convert start/end to CSS gradient angle
  // start: {x: 0, y: 0} end: {x: 1, y: 0} = left to right (90deg or 'to right')
  // start: {x: 0, y: 0} end: {x: 0, y: 1} = top to bottom (180deg or 'to bottom')
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  
  let direction;
  if (dx === 1 && dy === 0) {
    direction = 'to right';
  } else if (dx === 0 && dy === 1) {
    direction = 'to bottom';
  } else if (dx === -1 && dy === 0) {
    direction = 'to left';
  } else if (dx === 0 && dy === -1) {
    direction = 'to top';
  } else {
    // Calculate angle in degrees
    const angle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
    direction = `${angle}deg`;
  }

  const gradientColors = colors.join(', ');
  const backgroundImage = `linear-gradient(${direction}, ${gradientColors})`;

  return (
    <View
      {...props}
      style={[
        style,
        {
          backgroundImage,
        },
      ]}
    >
      {children}
    </View>
  );
};

export default LinearGradient;
